import { Button } from '@atlas/ui';
import { useEvidence } from '../EvidenceContext';

export function ExplainScreen({
  screenName,
  tour,
}: {
  screenName: string;
  tour?: string;
}) {
  const { openEvidence } = useEvidence();

  return (
    <Button
      variant="ghost"
      onClick={() =>
        openEvidence(
          `Explain: ${screenName}`,
          tour ??
            `Structured tour for ${screenName}: map principals, read costly signals, check portfolio survival constraints, then decide—including no action.`,
        )
      }
    >
      Explain this screen
    </Button>
  );
}
